export default __webpack_public_path__ + "static/media/renowork.e06a1598.jpg";